// @flow
import * as React from 'react';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import { IntlShape, injectIntl } from 'react-intl';
import point11Messages from 'esm-web-pro/messages/points11Messages';
import type { SFPDetailedRepresentation } from 'esm-web-pro/types/networks';
import sfpMessages from 'esm-web-pro/containers/pages/network/objects/sfp/sfpMessages';
import attributeMessages from 'esm-web-pro/messages/attributeMessages';
import StyledFormCheckmark from 'esm-web-pro/components/layout/sidePanel/icons/StyledFormCheckmark';
import { FormClose } from 'grommet-icons';
import dataPortMessages from 'esm-web-pro/messages/dataPortMessages';
import { memoize } from 'lodash';

type Props = {
    SFP: SFPDetailedRepresentation,
    url: string,
    intl: IntlShape,
    onView: Function,
}

const SFPAttributes = (props: Props) => {
    const {
        SFP, url, intl: { formatMessage }, onView,
    } = props;

    const {
        built_in: builtIn, optical_switch_port_count: opticalSwitchPortCount, model,
        data_port: {
            identity: dataPortIdentity, data_port_number: dataPortNumber,
            container: { identity: switchIdentity, oss_switch_name: ossSwitchName, container: point11 },
        },
    } = SFP;

    const getCapabilities = memoize(() => {
        const {
            capable_100M: capable100M, capable_1G: capable1G, capable_10G: capable10G, capable_40G: capable40G,
        } = SFP;

        const capabilitiesArr = [];

        if (capable100M) {
            capabilitiesArr.push(formatMessage(attributeMessages.capable100M));
        }
        if (capable1G) {
            capabilitiesArr.push(formatMessage(attributeMessages.capable1G));
        }
        if (capable10G) {
            capabilitiesArr.push(formatMessage(attributeMessages.capable10G));
        }
        if (capable40G) {
            capabilitiesArr.push(formatMessage(attributeMessages.capable40G));
        }

        return capabilitiesArr.length < 1 ? formatMessage(attributeMessages.noCapabilities)
            : capabilitiesArr.join(', ');
    });

    const attributes = [
        {
            label: formatMessage(attributeMessages.container),
            multiValue: [
                {
                    value: `${formatMessage(point11Messages[point11.type])} ${
                        point11.type === 'pop' && point11.alias
                            ? point11.alias
                            : point11.sequence
                    }`,
                    link: `${url.split('/layer')[0]}/layer/${point11.type}/${point11.identity}`,
                },
                {
                    value: ossSwitchName,
                    link: `${url.split('/layer')[0]}/layer/switch/${switchIdentity}`,
                },
                {
                    value: `${formatMessage(dataPortMessages.dataport)} ${dataPortNumber}`,
                    link: `${url.split('/layer')[0]}/layer/dataport/${dataPortIdentity}`,
                },
            ],
            separator: ', ',
        },
        {
            label: formatMessage(sfpMessages.Builtin),
            value: builtIn ? <StyledFormCheckmark /> : <FormClose />,
        },
        {
            label: formatMessage(attributeMessages.capabilities),
            value: `${getCapabilities()}`,
        },
        {
            label: formatMessage(sfpMessages.opticalPortsCount),
            value: opticalSwitchPortCount,
        },
    ];

    if (model) {
        attributes.push(...[{
            label: formatMessage(attributeMessages.model),
            value: model,
            link: model ? `${url}/model/${model.code}`.replace('//', '/') : '',
        },
        ]);
    }

    return (
        <Attributes attributes={attributes} />
    );
};

export default injectIntl(SFPAttributes);
